import type { MediaWrapperContainerTypeEnum } from '@/utils/aspectRatioUtils';
import { getAspectRatioForImages } from '@/utils/aspectRatioUtils';

import * as MS from '@/components/Cms/Card/components/MediaAndBottomTextType/MediaAndBottomTextType.styles';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import { useDeviceDetect } from '@/hooks/useDeviceDetect';
import { cleanObject } from '@/lib/util';
import { theme } from '@/theme';

import type { CardProps } from '../../types';
import { TextType } from '../TextType';

import * as S from './NarrowMediaAndBottomText.styles';
export const NarrowMediaAndBottomText = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };
  const { deviceType } = useDeviceDetect();

  const narrowbackgroundColor = {
    ...props?.backgroundColor,
    value: props?.backgroundColor?.value || theme.colors.white,
  };
  const headingTextColor = theme.colors.default;
  const narrowProcessedProps = {
    ...props,
    backgroundColor: narrowbackgroundColor,
    headingTextColor,
  };
  const hasMedia = !!(props.media?.image?.url ?? props.media?.video?.url);
  const aspectValue = props.aspectRatio ??
    getAspectRatioForImages(
      props.mediaWrapperType,
      null,
      null,
      null,
      deviceType,
    ) ?? { x: 4, y: 5 };
  return (
    <S.Container
      $backgroundColor={hasMedia ? 'transparent' : narrowbackgroundColor.value}
      $visibleInDesktop={_props.visibleInDesktop}
      $visibleInMobile={_props.visibleInMobile}
      data-test-id='MediaAndBottomTextTypeContainer'
    >
      {props.media?.image?.url && (
        <MS.MediaWrapper
          $aspectRatio={aspectValue}
          $mediaAnimationEffect={
            narrowProcessedProps.mediaAnimationEffect === 'zoomOnHover'
              ? narrowProcessedProps.mediaAnimationEffect
              : null
          }
        >
          <S.Media $backgroundAlignment={props.backgroundAlignment}>
            <MediaWrapper
              {...(props.media as ContentfulImageWithFocalPointFragment)}
              aspectRatio={aspectValue}
              cardGroupType={
                props.cardGroupType as MediaWrapperContainerTypeEnum
              }
              data-test-id='BaseCardTypeBackgroundImage'
              mediaWrapperType={props.mediaWrapperType}
              preload={props.preload}
              sizes='(max-width: 600px) 50vw, 100vw'
            />
          </S.Media>
        </MS.MediaWrapper>
      )}

      <TextType
        {...narrowProcessedProps}
        data-test-id='MediaAndBottomTextTypeTextType'
      />
    </S.Container>
  );
};
